import { client } from '@Utils'

export const saveAnswer = (coursenum, submissionId, questionGuid, answer) =>
  client.post(
    `/course/activity.json_save_answer/${coursenum}/${submissionId}/`,
    { question_guid: questionGuid, answer }
  )

export const submitAssessment = (coursenum, submissionId) =>
  client.post(
    `/course/activity.json_submit/${coursenum}/${submissionId}/`
  )

export const uploadFile = (coursenum, submissionId, questionGuid, file, onProgress) => {
  const formData = new FormData()
  formData.append('question_guid', questionGuid)
  formData.append('file', file)
  return client.post(
    `/course/activity.json_upload_file/${coursenum}/${submissionId}/`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    }
  )
}

export const deleteFile = (coursenum, submissionId, questionGuid, fileId) =>
  client.post(
    `/course/activity.json_delete_file/${coursenum}/${submissionId}/`,
    { question_guid: questionGuid, file_id: fileId }
  )

export const casesetSubmitQuestion = (coursenum, submissionId, questionGuid) =>
  client.post(
    `/course/activity.json_caseset_submit_question/${coursenum}/${submissionId}/`,
    { question_guid: questionGuid }
  )
